// extracted by mini-css-extract-plugin
export default {"container":"hI-z","error":"iI-z","disabled":"jI-z","submit":"kI-z","option":"lI-z","success":"mI-z","failure":"nI-z"};